import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate} from 'react-router-dom';

const corporateList = [
    {
        'key': '0',
        'name': ''
    },{
        'key': 'K社',
        'name': 'K社'
    },{
        'key': 'TIS',
        'name': 'TIS'
    },{
        'key': 'KSC',
        'name': 'KSC'
    },{
        'key': 'CJC',
        'name': 'CJC'
    },{
        'key': 'FPT',
        'name': 'FPT'
    },{
        'key': 'ソーバル',
        'name': 'ソーバル'
    },{
        'key': 'AGEST',
        'name': 'AGEST'
    },{
        'key': 'NRI',
        'name': 'NRI'
    }
];

const teamList = [
    {
        'key': '0',
        'name': ''
    },{
        'key': 'ASIST',
        'name': 'ASIST'
    },{
        'key': 'AS400',
        'name': 'AS400'
    },{
        'key': 'SFA3',
        'name': 'SFA3'
    },{
        'key': 'AS2',
        'name': 'AS2'
    },{
        'key': 'Global Support',
        'name': 'Global Support'
    },{
        'key': 'DA',
        'name': 'DA'
    },{
        'key': 'REX',
        'name': 'REX'
    },{
        'key': 'Web基盤',
        'name': 'Web基盤'
    },{
        'key': 'GIT',
        'name': 'GIT'
    },{
        'key': 'その他',
        'name': 'その他'
    }
];

function Register(){
    const [selectedOption, setSelectedOption] = useState('');
    const [isRegistered, setIsRegistered] = useState(false);
    const [selectedCorporate, setSelectedCorporate] = useState('');
    const [isRegistering, setIsRegistering] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [form, setForm] = useState(null);
    const [errors, setErrors] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if(localStorage.getItem('is2025') !== 'true'){
            reset();
        }
        localStorage.setItem('is2025', 'true')
        if(localStorage.getItem('userId')){
            setIsRegistered(true);
        }
        setForm(JSON.parse(localStorage.getItem('form')));
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const entries = Object.fromEntries(formData.entries());
        let corporateMessage = '';
        let teamMessage = '';
        let nameMessage = '';
        if(entries.selectedCorporate == null || entries.selectedCorporate === '0' ){
            corporateMessage = '会社を選択してください'
        }
        if(entries.selectedTeam == null || entries.selectedTeam === '0' ){
            teamMessage = 'チームを選択してください';
        }
        if(entries.inputedName === ''){
            nameMessage = '名前を入力してください';
        }
        if(corporateMessage !== ''
            || teamMessage !== ''
            || nameMessage !== ''){
            setErrors({
                corporate: corporateMessage,
                team: teamMessage,
                name: nameMessage
            });
            return;
        }
        setErrors(null);
        setForm({
            'corporate': entries.selectedCorporate,
            'team': entries.selectedTeam,
            'name': entries.inputedName
        });
        setShowDialog(true);
    }

    const handleRegister = () => {
        setShowDialog(false);
        register(form);
        setIsRegistering(true);
    }
    
    const register = async () => {
        const result = await axios.post('https://4m8qo3vqvl.execute-api.us-east-1.amazonaws.com/Product', {
            'call': 'PUT /user',
            'body': JSON.stringify(form)
        });
        localStorage.setItem('userId', result.data.body);
        localStorage.setItem('form', JSON.stringify(form));
        navigate('./category');
    }
    
    const cancel = () => {
        setShowDialog(false);
    }

    const selectRadio = (e) => {
        setSelectedCorporate(e.target.getAttribute('value'));
        return false;
    }
    
    const reset = () => {
        localStorage.setItem('userId', '');
        localStorage.setItem('isVoted', false);
        localStorage.setItem('category', null);
        localStorage.setItem('option', null);
        setIsRegistered(false);
    }

    const ok = () => {
        const isVoted = localStorage.getItem('isVoted');
        if(isVoted){
            navigate('./results');
        }
        navigate('./category');
    }

    return (
        <div className='main'>
            <div className='header-div'>
            <img src='./img/header-removebg-preview.png'></img>
            </div>
            <div className='body-div'>
            {!isRegistering && !isRegistered
            && 
                <div>
                    {/* <h1>会社名、チーム、名前 (フルネーム) を入力してください</h1> */}
                    <form method='POST' onSubmit={handleSubmit}>
                        <div className='form-div'>
                            <label>
                                <div className='label'>会社名</div>
                                <div className='input select'>
                                    <select name='selectedCorporate'>
                                    {corporateList.map((corporate, index) => (
                                        // <div className='radio-group-item' onClick={(e) => selectRadio(e)} key={corporate.key} value={corporate.key} area-checked={(corporate.key === selectedCorporate).toString()}>{corporate.name}</div>
                                        <option key={index} value={corporate.key}>{corporate.name}</option>
                                    ))}
                                    </select>
                                </div>
                                {errors?.corporate && errors.corporate !== ''
                                    && <p className='error-message'>{errors.corporate}</p>}
                            </label>
                        </div>
                        <div className='form-div'>
                            <label>
                                <div className='label'>チーム</div>
                                <div className='input select'>
                                    <select name='selectedTeam'>
                                        {teamList.map((team, index) => (
                                            <option key={index} value={team.key}>{team.name}</option>
                                        ))}
                                    </select>
                                </div>
                                {errors?.team && errors.team !== ''
                                    && <p className='error-message'>{errors.team}</p>}
                            </label>
                        </div>
                        <div className='form-div'>
                            <label>
                                <div className='label'>名前 (ひらがなフルネーム)</div>
                                <input className='input' type='text' name='inputedName' />
                                {errors?.name && errors.name !== ''
                                    && <p className='error-message'>{errors.name}</p>}
                            </label>
                        </div>
                        <button className='submit-button' type="submit">登録</button>
                    </form>
                    {showDialog
                    &&
                    <div className='curtain'></div>
                    }
                    {showDialog
                    &&
                    <div className='dialog'>
                        <p className='confirm-message'>{corporateList.find(x => x.key === form.corporate).name} {teamList.find(x => x.key === form.team).name}チームの {form.name} さんで間違いないですか？</p>
                        <p className='message' style={{fontWeight: 'bold'}}>※登録は取り消せません</p>
                        <div className='button-div'>
                        <button onClick={() => cancel()}>間違えた</button>
                        <button className='submit-button' onClick={() => handleRegister(selectedOption.key)}>間違いない</button>
                        </div>
                    </div>
                    }
                </div>
            }
            {isRegistered
            && 
                <div className='dialog'>
                    <p>あなたは{corporateList.find(x => x.key === form.corporate).name} {teamList.find(x => x.key === form.team).name}チームの {form.name} さんとして登録済みです</p>
                    <p>※登録は取り消せません</p>
                    <div className='button-div'>
                    {/* <button onClick={() => reset()}>リセット</button> */}
                    <button className='submit-button' onClick={() => ok()}>わかった</button>
                        </div>
                </div>
            }
            {isRegistering
            && <div style={{display: 'flex'}}>
                <div className='loader'></div>
                <p>登録中</p>
                </div>
            }
        </div>
        </div>
    );
}
    
export default Register;